import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar_poc'
import ShapeTwo from '../components/shape-two'
import TeamOne from '../components/team-one'
import Shape from '../components/shape'
import Footer from '../components/footer'

// import bg1 from '../assets/images/bg.jpg'
import bg1 from '../assets/images/bg-profile.jpg'
import RAWlogo from '../assets/images/cover5.png'
import B2Blogo from '../assets/images/B2BLogoRound.png'
import { feature } from '../data'
import { lawyerServices} from '../data/data'
export default function Podcasts() {
  return (
    <>
     <Navbar/> 
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Two Podcasts</h4>
                          <p className="text-muted mb-0">One Mission</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          {/* <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li> */}
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Podcasts</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>
      <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <p className="text-muted para-desc mx-auto mb-0">Growth with India — in business and in life.</p>
                      <p>Pioneer One Global brings you stories and strategies from the boardroom to the running path. Explore our two podcasts below.</p>
                  </div>
              </div>
          </div>

          <div className="row">
          <div className="col-md-6 col-12 mt-4 pt-2">
  <div className="team-list position-relative overflow-hidden shadow rounded text-center p-4">
    <img height="100" src={B2Blogo} className="img-fluid mb-3" alt=""/>
    <h5 className="title mb-0">Bridge to Bharath</h5>
    <p className="text-muted mt-3">
      A tactical playbook for succeeding in India without the million-dollar mistakes.
    </p>
    <div className="col-12 mt-4 d-flex justify-content-center">
      <Link to="/bridgetobharath" className="btn btn-primary">
        <i className="mdi mdi-phone-outline"></i> Explore Bridge to Bharath
      </Link>
    </div>
  </div>
</div>
<div className="col-md-6 col-12 mt-4 pt-2">
  <div className="team-list position-relative overflow-hidden shadow rounded text-center p-4">
    <img height="100" src={RAWlogo} className="img-fluid mb-3" alt=""/>
    <h5 className="title mb-0">Roots and Wings</h5>
    <p className="text-muted mt-3">
    Stories of growth, resilience, and meaning — from marathons to mindsets, parenting to purpose.
    </p>
    <div className="col-12 mt-4 d-flex justify-content-center">
      <Link to="/podcast" className="btn btn-primary">
        <i className="mdi mdi-phone-outline"></i> Explore Roots and Wings
      </Link>
    </div>
  </div>
</div>
           </div>
                   <div className="row">
                   <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Why Two Podcasts?</h4>
                      <p className="text-muted description">Because growth has two sides.</p>
<ul className="list-inline mb-0">
                      <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Bridge to Bharath helps companies navigate India with tactical precision.</li>
                      <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Roots and Wings helps individuals and leaders find resilience and meaning.</li>
                        </ul>
                       <p className="text-muted description">Together, they reflect Pioneer One Global’s vision: growth isn’t just about market share, it’s about human depth.</p>
                       
                  </div>
              </div>
          </div>
                      </div>

          {/* <div className="row">
            {featureData.map((item,index)=>{
              return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="feature p-3 py-4 rounded">
                        <i className={`mdi mdi-layers-triple-outline text-primary float-start me-3 mt-2 mdi-36px ${item.icon}`}></i>
                        <div className="content d-block overflow-hidden">
                            <h4 className="title">{item.title}</h4>
                            <p className="text-muted mt-2">{item.desc}</p>
                            <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
              )
            })}
          </div> */}
      </div>
    </section>
    <section className="section">
      {/* <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">We provide everything you need to establish a successful business presence in India — legally, quickly, and confidently. And with our AI expertise, we help you scale smarter, faster, and leaner.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {feature.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <Icon className="h2 text-primary"/>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.shortDescription}</p>
                            <Link to={`/page-service-single/${item.id}`}  className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div> */}

      <div className="container mt-4">
          <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4>Ready to grow with India?</h4>
                       </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="/contact" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Let's talk!</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
